import PremiumGoal from './PremiumGoal'

export default PremiumGoal
